import styled from "styled-components";

export default styled.div`
  position: fixed;
  top: 20%;
  left: 25%;
  width: 50%;
  background-color: ${({ theme }) => theme.deprecatedColors.background};
  z-index: 200;
  border-radius: ${({ theme }) => theme.deprecatedBorder.radius.large};
  max-height: 75vh;
  overflow-y: scroll;

  .modal-image {
    border: 1px solid red;
  }

  @media ${({ theme }) => theme.deprecatedBreakpoints.large} {
    width: 80vw;
    left: 10vw;
  }

  @media ${({ theme }) => theme.deprecatedBreakpoints.small} {
    width: 96vw;
    left: 2vw;
  }
`;
